module.exports = __webpack_public_path__ + "img/banner.9db26ebf.png";